/* eslint-disable no-nested-ternary */
import CustomRefreshButton from 'Components/common/components/CustomRefreshButton';
import {
  maxMobile, maxTablet, smMobile,
} from 'Utils/utilsStyle';
import styled from 'styled-components';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCompanyProfile,
  selectProfileLoading,
  selectRefreshCompanyIds, selectSWOTData, selectSWOTLoading,
} from 'Selector/CompaniesSelector';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  IsMobile, getCurrentTime, valueToObject,
} from 'Utils/UtilityFunctions';
import { actions as companiesActions } from 'Slice/CompaniesSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { COMPANY_SWOT_ROUTE, SWOT_ANALYSIS, TOOLTIP_SWOT } from 'Utils/Constants';
import UpdatedPill from './UpdatedPill';
import SwotPillDesk from './SwotPillDesk';
import ViewSwitcher from './ViewSwitcher';

const Wrapper = styled.div`
  .swot-head-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 21px;
    .first-row {
       @media all and (max-width: ${maxMobile}) {
        width: 100%;
        display: flex;
        justify-content: flex-start;
      }
    }
    .left-side-div-swot {
      .responsive-update-switch {
        display: flex;
        align-items: center;
        @media all and (max-width: ${maxMobile}) {
          margin-top: 10px;
        }
      }
      .heading {
        @media all and (max-width: ${maxMobile}) {
          align-items: center;
          display: flex;
          margin-left: 0px;
        }
      }
    }
    .right-side-div-swot {
      display: flex;
      align-items: center;
      @media all and (max-width: ${maxMobile}) {
        align-self: flex-start;
      }
      .head-trigger {
        display: flex;
        align-items: center;
         margin-right: 15px;
        @media all and (max-width: ${maxTablet}) {
          margin-right: 10px;
        }
        @media all and (max-width: ${smMobile}) {
          margin-right: 5px;
        }
      }
      .custom-refresh-button {
        margin-right: 15px;
        display: flex;
        @media all and (max-width: ${maxTablet}) {
          margin-right: 10px;
        }
        @media all and (max-width: ${smMobile}) {
          margin-right: 5px;
        }
      }
      .disable {
        opacity: 0.6;
        pointer-events:none;
      }
    }
  }
`;

type Props = {
  isSwotTab: boolean;
};

const SwotAnalysis = function SwotAnalysis(props: Props) {
  const { isSwotTab } = props;
  const swotLoading = useSelector(selectSWOTLoading);
  const companyProfileLoading = useSelector(selectProfileLoading);
  const swotData = useSelector(selectSWOTData);
  const [viewAll, setViewAll] = useState(false);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;

  const dispatch = useDispatch();
  // const xsmMob = IsMobileXsm();
  const isMob = IsMobile();
  const refreshCompanyIds = useSelector(selectRefreshCompanyIds);
  const companyProfile = useSelector(selectCompanyProfile);
  const refreshSpecficCompany: boolean = refreshCompanyIds.includes(companyIdParsed);

  const { swotAnalysis, createdAt } = swotData;
  const [params] = useSearchParams();
  const fromNewsTab = params.get('fromNewsTab');

  const handleRefresh = () => {
    const startTime = getCurrentTime();
    const data = {
      companyId: companyIdParsed,
    };
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('company_swot_refresh', startTime, { ...data }),
    ));
    const message = `SWOT analysis of ${companyProfile?.companyName as string} is being updated, it might take 3 to 4 minutes.`;
    dispatch(flurryActions.setNotification({
      message,
      proTip: false,
      rightPlacement: false,
      groupId: 0,
      classnameFlag: true,
      companyId: companyIdParsed,
    }));
    dispatch(companiesActions.refreshSWOTAnalysis(data));
  };

  const toggleSwotView = () => {
    setViewAll(!viewAll);
  };

  return (
    <Wrapper>
      <div className="heading-inner-page">
        <div className="swot-head-row">
          <div className="d-flex align-items-center first-row">
            <div className="left-side-div-swot">
              <h1 className="d-flex align-items-center heading">
                {SWOT_ANALYSIS}
                <HeadingWithToolTip
                  heightIcon="18px"
                  heightIconXSm="17px"
                  toolTipText={TOOLTIP_SWOT}
                />
              </h1>
              {isMob ? (
                isSwotTab
                  ? (
                    <div className="responsive-update-switch">
                      {refreshSpecficCompany || swotLoading ? null : (
                        <UpdatedPill
                          date={createdAt}
                        />
                      )}
                      {swotLoading && companyProfileLoading ? null
                        : (
                          <ViewSwitcher
                            swotTab
                            tabCheck={fromNewsTab ? !viewAll : viewAll}
                            swotToggle={toggleSwotView}
                            disabledViewAction={false}
                          />
                        )}
                    </div>
                  ) : (
                    <div className="responsive-update-switch">
                      {refreshSpecficCompany || swotLoading ? null : (
                        <UpdatedPill
                          date={swotData?.createdAt}
                        />
                      )}
                      {swotLoading ? null
                        : (
                          <ViewSwitcher
                            tabCheck={fromNewsTab ? false : viewAll}
                            redirectUrl={`${COMPANY_SWOT_ROUTE}${companyId || ''}&fromNewsTab=true`}
                            disabledViewAction={false}
                          />
                        )}
                    </div>
                  )
              ) : null}
            </div>
          </div>
          <div className="right-side-div-swot">
            {!isMob && !refreshSpecficCompany && !swotLoading ? (isSwotTab
              ? (
                <UpdatedPill
                  date={createdAt}
                />
              ) : (
                <UpdatedPill
                  date={swotData?.createdAt}
                />
              )
            ) : null}
            {swotData?.refresh && !swotLoading
              ? (
                <CustomRefreshButton
                  onRefresh={handleRefresh}
                  buttonText={refreshSpecficCompany ? 'Refreshing' : 'Refresh'}
                />
              ) : null}
            {!isMob && !swotLoading ? (isSwotTab
              ? (
                <ViewSwitcher
                  swotTab
                  tabCheck={fromNewsTab ? !viewAll : viewAll}
                  swotToggle={toggleSwotView}
                  disabledViewAction={false}
                />
              ) : (
                <ViewSwitcher
                  tabCheck={fromNewsTab ? false : viewAll}
                  redirectUrl={`${COMPANY_SWOT_ROUTE}${companyId || ''}&fromNewsTab=true`}
                  disabledViewAction={false}
                />
              )
            ) : null}
          </div>
        </div>
      </div>
      <div className="swot-tab-area">
        <SwotPillDesk
          isSwotTab={isSwotTab}
          viewLess={fromNewsTab ? viewAll : !viewAll}
          showRefreshPopup={refreshSpecficCompany}
          swotData={swotAnalysis}
          swotLoading={swotLoading}
        />
      </div>
    </Wrapper>
  );
};
export default SwotAnalysis;
